
import { Edit } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import DialogModifierDossier from '../../../Components/Dialogs/DialogModifierDossier';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { StatutDosier } from '../../../data/Interfaces';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { countCandidatureByStatus } from '../AOs/AllAOs';

const AllDossiers = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();

    const columns = [
        {
            field: 'eye',
            title: i18n.t('Option'),
            render: rowData => {
                return (
                    <IconButton
                        onClick={() => {
                            setSelectedDossier(rowData);
                            setOpenClasser(true);
                        }}
                    >
                        <Edit />
                    </IconButton>
                );
            },
        },
        {
            field: 'dossierId',
            title: i18n.t('Réf.Dossier'),
            render: rowData => {
                return (
                    <Button
                        onClick={() => navigate(`/admin/dossier/${rowData?._id}`)}
                    >
                        {rowData?.dossierId}
                    </Button>);
            }
        },
        {
            field: 'clientId',
            title: i18n.t('Réf.Client'),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom client'),
        },
        {
            field: 'nomDossier',
            title: i18n.t('Nom dossier'),
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => (
                <>
                    {i18n.t(searchLabelInEnumByValue(StatutDosier, rowData?.statut))}
                </>
            )
        },
        {
            field: 'nbCandidatures',
            title: i18n.t('Nbr des CV'),
        },
        {
            field: 'countInterviewed',
            title: i18n.t('Candidatures "à interviewer"'),
        },
        {
            field: 'countRetained',
            title: i18n.t('Candidatures "Retenues"'),
            // * in case it couldn't get the value at time:
            //  render: rowData => (
            //     <>
            //         {countCandidatureByStatus(rowData?.candidatures)?.countRetained}
            //     </>
            // )
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début Mission'),
            render: rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>
            )
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date fin Mission'),
            render: rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateFinMission)}
                </>
            )
        },
        {
            field: 'localisation',
            title: i18n.t('Localisation'),
        },
        {
            field: 'dureeBDC',
            title: i18n.t('Durée du BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeBDC, 'mois');
            }
        },
        {
            field: 'dureeMission',
            title: i18n.t('Durée Mission'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeMission, 'j');
            }
        },
        {
            field: 'tjMax',
            title: i18n.t('Budget Max/j'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tjMax);
            }
        },
        {
            field: 'createur',
            title: i18n.t('Créé par'),
        },
        {
            field: 'dateCreation',
            title: i18n.t('Date création Dossier'),
        },
    ];
    const [openClasser, setOpenClasser] = useState(false);
    const [dossierList, setDossierList] = useState([]);
    const { data: dossiers, refresh } = useGetRequest({ url: '/cvTheque/getAllDossiers' });
    const [selectedDossiers, setSelectedDossiers] = useState([]);
    const [selectedDossier, setSelectedDossier] = useState();
    const { postData } = usePostRequest();

    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [candidatRetenu, setCandidatRetenu] = useState(searchParams.get('candidatRetenu') === 'true');
    const [filtre, setFiltre] = useState(searchParams.get('filtre') === 'true');

    const mapDossier = (dossier) => {
        return {
            'dossierId': dossier?.dossierId,
            'nomDossier': dossier?.nom,
            'nomClient': dossier?.companyDataId?.profileEntreprise?.nom ?? dossier?.esnId?.profileEntreprise?.nom,//was : dossier?.collaboratorId?.companyDataId
            'clientId': dossier?.companyDataId?.clientId ?? dossier?.esnId?.esnId,
            //statut d'un dossier cloture ou en cours faut ajouter un btn cloturer dans mes dossier
            'statut': dossier?.statut,
            'nbCandidatures': dossier?.candidatures?.length,
            'countInterviewed': countCandidatureByStatus(dossier?.candidatures)?.countInterviewed,
            'countRetained': countCandidatureByStatus(dossier?.candidatures)?.countRetained,
            //à faire by reda
            'localisation': dossier?.localisation,
            'tjMax': dossier?.tjMax,
            'dateCreation': formatDateJJMMYYYY(dossier?.createdAt),
            'dateDebutMission': formatDateJJMMYYYY(dossier?.dateDebutMission),
            'dureeBDC': dossier?.dureeBDC,
            'dureeMission': dossier?.dureeMission,
            'createur': getNomPrenomClearFromPersoData(dossier?.collaboratorId?.persoData ?? dossier?.collaboratorEsnId?.persoData),
            ...dossier,
        };

    };

    useEffect(() => {
        if (dossiers) {
            let tempArr = [];
            let temp_retained = 0;
            if (filtre == true) {
                dossiers?.reverse().forEach(dossier => {
                    if (dossier?.statut == 'encours') {
                        tempArr.push(mapDossier(dossier));
                    }
                });
            }
            else if (candidatRetenu == true) {
                dossiers?.reverse().forEach(dossier => {
                    temp_retained = countCandidatureByStatus(dossier?.candidatures)?.countRetained;
                    if (dossier?.statut == 'encours' && temp_retained > 0) {
                        tempArr.push(mapDossier(dossier));
                    }
                });
            }
            else {
                dossiers?.reverse().forEach(dossier => {
                    tempArr.push(mapDossier(dossier));
                });
            }
            setDossierList(tempArr);
        }
    }, [dossiers, filtre]);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if (url && !url.toLowerCase().includes('candidatretenu') && !url.toLowerCase().includes('filtre')) {
            setCandidatRetenu(false);
            setFiltre(false);
            refresh();
        }
    }, [url]);

    const cloturerDossiers = async () => {
        if (selectedDossiers.length > 0) {
            await postData({ url: '/cvTheque/cloturerDossiers', payload: { dossierIds: selectedDossiers.map((dossier) => dossier?._id) } })
                .then(() => {
                    refresh();
                    setSelectedDossiers([]);
                }).catch((err) => console.log(err));
        }
    };

    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('Gestion des candidatures')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {i18n.t('CvThèque')}</span>
            </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Dossiers clients')}
                </h4>
                <div style={{ justifyContent: 'flex-end', alignSelf: 'stretch', display: 'flex' }}>
                    <Button
                        variant="contained"
                        style={{ ...buttonStylesGreen((selectedDossiers.length > 0 ? false : true)) }}
                        onClick={cloturerDossiers}
                    > {i18n.t('Clôturer le dossier')}
                    </Button>
                </div>

                <MaterialTableComponent
                    columns={columns}
                    data={dossierList}
                    title={i18n.t('DossierList et BDC')}
                    onRowClick={(event, rowData) => {
                        // navigate(`/admin/dossier/${rowData?._id}`);
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                    options={{
                        selection: true
                    }}
                    onSelectionChange={(rows) => {
                        setSelectedDossiers(rows);
                    }}
                />
                {openClasser &&
                    <DialogModifierDossier
                        selectedDossier={selectedDossier}
                        openClasser={openClasser}
                        handleCloseClasser={() => {
                            setOpenClasser(false);
                            refresh();
                        }}
                    />}
            </div>
        </>
    );
};

export default AllDossiers;